import React from 'react';


const LanguageBtn = () => {
  return (
   <div>
     
     <div className="mybutton">
     <button className="btn-floating btn-lg red waves-effect waves-light createButton" title="Choose Language">
     <i className="fa fa-language" aria-hidden="true"></i>
      </button>
    </div>
    
   </div>
  );
}

export default LanguageBtn;